(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Korei18nPluginSDK"] = factory();
	else
		root["Korei18nPluginSDK"] = factory();
})(self, () => {
return 